module.exports = __webpack_public_path__ + "media/icefrog.2b932038.webm";